import TransactionsTableItemLoading from './TransactionsTableItemLoading'

export default TransactionsTableItemLoading
